import { Text, VStack } from './Atoms'

export type DetailItemProps = {
  label: string
  children: React.ReactNode
  className?: string
}

export function DetailItem(props: DetailItemProps) {
  return (
    <VStack gap="xs" className={props.className}>
      <Text size="xs" tone="muted">
        {props.label}
      </Text>
      {typeof props.children === 'string' ? <Text>{props.children}</Text> : props.children}
    </VStack>
  )
}
